import { WithAccountId } from '@mews-commander/types';
import { ModalLink } from '../../../../../components';
import { useGetInfoAccount } from '../../../utils';

export const BillAccountCompanyLink = ({ accountId }: WithAccountId) => {
    const accountInfo = useGetInfoAccount({ accountId });

    if (!accountInfo.url || !accountInfo.isCompany) {
        return null;
    }
    return <ModalLink url={accountInfo.url}>{accountInfo.name}</ModalLink>;
};
